Helpful = window.Helpful || {};

Helpful.init = function(options) {
	var $body = $('body'),
		$yes = $('div.helpful #fieldset_yesFieldset');
	$yes.wrapInner('<div class="wrap" />');

	$('div.helpful #fieldset_noFieldset input[type=radio]').each(function() {
		$(this).parent().before(this);
	});

	$('#helpful-1').click(function(e) {
		Helpful.helpfulPost();
		$('#fieldset_noFieldset').hide();
	});
	$('#helpfulBtn').click(function(e) {
		if (!$body.hasClass('helpful-open')) {
			$('#fieldset_noFieldset').slideDown();
			$(this).addClass('selected');
			$('#fieldset_yesFieldset').addClass('open');
			$body.addClass('helpful-open');

			if ($body.width() > 992-15) {
				var scrollPosition = $(window).scrollTop() + 287;
				$("html, body").animate({scrollTop: scrollPosition}, 600);
			}
		}
		else {
			$('#fieldset_noFieldset').slideUp();
			$('#helpfulBtn').removeClass('selected');
			Helpful.helpfulReset();
		}

	});
	$('#helpful_submit').click(function(e) {
		Helpful.helpfulPost();
	});
	$('#helpful_cancel').click(function(e) {
		$('#fieldset_noFieldset').slideUp();
		$('#helpfulBtn').removeClass('selected');
		Helpful.helpfulReset();
	});
	$(document).mouseup(function (e) {
		var container = $('div.helpful');
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('#fieldset_noFieldset').slideUp();
			$('#helpfulBtn').removeClass('selected')
			Helpful.helpfulReset();
		}
	});
	$('#fieldset_noFieldset #elm_reason .radio').click(function() {
		$('#fieldset_noFieldset #extra').focus();
		$('#fieldset_noFieldset #elm_extra label').text(options.language.explain);
	});

	$('#helpful-success').append($('#helpful-success').data('text'));
};
